<template>
    <div id="application-wrapper">
        <section class="modal recover-password onboarding">
            <div class="inner">
                <div class="section-header">
                    <i class="back" @click="goStepBack"></i>
                    <span class="title">{{title}}</span>
                </div>

                <div v-if="invalidKey" class="section-body">
                <div  id="recover__form" class="step">
                  <div class="form-inner">
                    <div class="headline">{{trans('invalid_token_message')}}</div>

                    <button
                        type="button"
                        class="btn btn-primary btn-rounded btn-long"
                        @click="try_again"
                    >
                      {{trans('try_again')}}
                    </button>
                  </div>
                </div>
              </div>
                <div  v-else-if="!sentScreen" class="section-body recover">
                  <div id="recover__form" class="step">
                    <form data-abide2 data-vv-scope="recoverForm"  @submit.prevent="submitForm">
                      <div class="form-inner">
                        <div class="headline recover">{{ trans('last_your_password_title') }}</div>
                        <label>
                          <input
                              v-model="email"
                              type="text"
                              name="email"
                              class="form-control dark"
                              :placeholder="trans('email_or_handle')"
                              :data-vv-as="trans('email')"
                              v-validate="'required'"
                              :class="{'is-invalid-input': errors.has('recoverForm.email')}"
                              required>

                          <span class="form-error" v-show="errors.has('recoverForm.email')" :class="{'is-visible': errors.has('recoverForm.email')}">
                                        {{ errors.first('recoverForm.email') }}
                                    </span>
                        </label>
                        <button class="btn btn-rounded btn-primary btn-long" id="btn-recover" type="submit">
                          {{ trans('request_recovery_link') }}
                        </button>
                      </div>
                    </form>
                    <div class="form-enter-code">
                      <form id="enterCodeForm" data-abide2 data-vv-scope="enterCodeForm" class="step" @submit.prevent="submitCodeForm">
                        <div class="form-inner">
                          <div class="headline recover enter_code">{{trans('enter_code_here')}}</div>
                          <div  class="enter_code">
                            <label>
                              <input
                                  v-model="recovery_code"
                                  type="text"
                                  name="recovery_code"
                                  class="form-control dark"
                                  :placeholder="trans('recovery_code')"
                                  :data-vv-as="trans('recovery_code')"
                                  v-validate="'required|min:6'"
                                  :class="{'is-invalid-input': errors.has('enterCodeForm.recovery_code')}"
                                  required>

                                <span class="form-error" v-show="errors.has('enterCodeForm.recovery_code')" :class="{'is-visible': errors.has('enterCodeForm.recovery_code')}">
                                          {{ errors.first('enterCodeForm.recovery_code') }}
                                </span>
                            </label>
                            <button class="btn btn-rounded btn-primary" id="btn-enter-code" type="submit">
                              {{ trans('enter') }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div class="form-footer">
                      <a href="#" @click="help($event)" class="">Need help?</a>
                    </div>
                  </div>
                </div>
                <div v-else class="section-body recover">
                <div  id="message_sent" class="step">
                  <div class="form-inner">
                    <div class="headline" v-html="trans('we_sent_recovery_link')"></div>

                    <div>
                      <span class="underline">Didn't get the email?</span>
                      <ul>
                        <li><span>{{trans('check_folder')}}</span></li>
                        <li><span>{{trans('make_sure_you_entered')}}</span></li>
                        <li><span>{{trans('request_new_link')}}</span></li>
                      </ul>
                    </div>
                    <div>
                      <button
                          type="button"
                          @click="sentScreen = 0"
                          class="btn btn-primary btn-rounded btn-long"
                          id="button-send-code"
                      >
                        {{trans('enter_code')}}
                      </button>
                      <button
                          type="button"
                          @click="openHome"
                          class="btn btn-default btn-rounded"
                          id="button-home"
                      >
                        {{trans('home.home')}}
                      </button>
                    </div>
                  </div>
                  <div class="form-footer">
                    <a href="#" @click="help($event)">Need help?</a>
                  </div>
                </div>
              </div>
            </div>
        </section>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        data() {
            return {
                email: '',
                recovery_code: '',
                sentScreen: false,
                invalidKey: false
            }
        },
        mixins: [require('@general/lib/mixin').default],
        computed:{
          title(){
            return this.sentScreen ? this.trans('check_inbox')  : this.trans('recover_password')
          }
        },
        created() {
            this.email = sessionStorage.getItem('home.loginEmail');
            sessionStorage.removeItem('home.loginEmail');
        },
        methods: {
            try_again(){
              this.invalidKey = false;
            },
            help(event) {
              if (typeof zE != "undefined") {
                event.preventDefault()
                zE.activate()
              }else{
                console.log('ZE not exists');
              }
            },
            goStepBack(fallback) {
                if(this.sentScreen){
                  this.sentScreen = false
                }else{
                  window.location.href = window.location.origin
                }
            },
            openHome(){
              window.location.href = '/'
            },
            async submitCodeForm(){
              this.process = true
              this.showLoadingButton('#btn-enter-code');
              try {
                let response = await axios.get('/magicLinkAuth?code='+this.recovery_code)
                if (response.status === 200) {
                  if(response.data.token){
                    sessionStorage.setItem('token', response.data.token);
                    sessionStorage.setItem('userId', response.data.user_id);

                    localStorage.removeItem('userId');
                    localStorage.removeItem('token');
                    localStorage.removeItem('remember_login');
                    window.location.href = '/discover';
                  }else{
                    this.errors.add({
                      field: 'enterCodeForm.recovery_code',
                      msg: 'Invalid code'
                    });
                  }
                }
                console.log('[Password Reset Form] Result', { response })

                this.process = false
                this.restoreLoadingButton('#btn-enter-code')

              } catch (error) {
                console.log('[Password Reset Form] Error', { error })

                this.errors.add({
                  field: 'enterCodeForm.recovery_code',
                  msg: 'Invalid code'
                });
              }
              this.restoreLoadingButton('#btn-enter-code')

              this.process = false
            },
            async submitForm() {
                this.showLoadingButton('#btn-recover')
                let valid = await this.$validator.validateAll('recoverForm')
                if (!valid) {
                    this.restoreLoadingButton('#btn-recover')
                    return
                }

                let response = await axios.post('/api/password/email', {
                    email: this.email,
                    lang: app.lang
                })

                this.sentScreen = true;
                this.restoreLoadingButton('#btn-recover')
                if (response.status === 200) {
                    this.showSuccessNotification(response.data.message)
                }
            }
        },
        beforeMount() {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);

          const invalid_token = urlParams.get('invalid_token');
          if(invalid_token){
            this.invalidKey = true;
          }
        }
    }
</script>
